<!-- <ion-header class="custom-ion-header" [ngStyle]="{'height': headerHeight}"> -->
  <!-- <app-app-header  [title]="pageTitle" [showBackBtn]="showBackBtn"
    [defaultUrl]="defaultUrl" [showFirstIcon]="showFirstIcon" [showSecondIcon]="showSecondIcon"
    [firstIconName]="firstIconName" [secondIconName]="secondIconName" [iconPosition]="iconPosition" (firstIconClick)="notificationHeaderClick()" (secondIconClick)="profileHeaderClick()"></app-app-header> -->

    <ion-toolbar mode="ios" class="toolbar" [ngStyle]="{'height': headerHeight}">
      <ion-back-button text="" aria-label="dismisstest"
      role="dismisstest" 
      Accessibility-ID="dismisstest"  (click)="dismiss()" style="color: white;padding-top:10px"  slot="start" defaultHref="">
      </ion-back-button>
      <ion-buttons style="padding-top:10px" [slot]="iconPosition"> 
        <ion-icon class="icon-color" aria-label="notificationHeader-test"
        role="notificationHeader-test" 
        Accessibility-ID="notificationHeader-test" slot="icon-only" name="notifications-outline" (click)="notificationHeaderClick()"></ion-icon>
        <ion-icon class="icon-color"  aria-label="person-circle-test"
        role="person-circle-test" 
        Accessibility-ID="person-circle-test" slot="icon-only" name="person-circle" (click)="profileHeaderClick()"></ion-icon>
      </ion-buttons>
      <ion-title style="padding-top:10px;color:white;">
        <ion-text  style="font-weight: bolder;">{{pageTitle}}</ion-text><br>
      </ion-title>
    </ion-toolbar>
  <!-- </ion-header> -->

<ion-content>
  <div class="card-div">
    <ion-row class="ratings_heading_row">
      <ion-col  class="ion-align-self-center">
        <ion-label class="ratings_label">{{typeName}} ({{areaWiseRatingList.length}})</ion-label>
      </ion-col>
      <ion-col size="auto">
        <ion-chip class="filter ion-activatable ripple-parent" aria-label="ratingDetails-test"
        role="ratingDetails-test" 
        Accessibility-ID="ratingDetails-test" (click)="ratingDetails('filter')">
          <ion-label>{{'TREASURE_HUNT.TEAM_SELECTION.FILTER' | translate}}</ion-label>
          <img class="filter_icon" src="./assets/img/action_mgmt/Filter.svg"/>
          <ion-ripple-effect></ion-ripple-effect>
        </ion-chip>

        <ion-chip class="filter ion-activatable ripple-parent" aria-label="sort-test"
        role="sort-test" 
        Accessibility-ID="sort-test" (click)="ratingDetails('sort')">
          <span class="span_text"> {{'ACTION_MANAGEMENT.ACTION_SORTBY' | translate}} :</span>
          <b class="bold-text">{{sortingLabel}}</b>
          <ion-icon style="height: 14px;
            margin-top: 2px;color:#007382;" name="chevron-down-outline"></ion-icon>
          <ion-ripple-effect></ion-ripple-effect>
        </ion-chip>
      </ion-col>
    </ion-row>
  </div>
  <ion-grid style="margin:-30px 20px 0 20px;padding-bottom:100px;">
  
    <ion-list lines="none">
      <div *ngFor="let item of areaWiseRatingList,let i=index">
        <div style="box-shadow: 0px 3px 6px #00000029;" [attr.aria-label]="'openCollapse-test'+i"
        [attr.role]="'openCollapse-test'+i" 
        [attr.Accessibility-ID]="'openCollapse-test'+i" class="ion-activatable ripple-parent rating_list" (click)="openCollapse(i)">
          <ion-row class="rating_list_first_row">
            <ion-col class="ion-align-self-center">
              <div class="rating_list_id">
                {{item.plant}}
              </div>
              <div class="rating_list_id">
                <ion-label class="rating_list_id_alias">{{item.area_name}}</ion-label>
              </div>
              <div class="rating_list_date">
                {{item.submitted_date | date:'MMMM/yyyy'}}
              </div>
            </ion-col>
          </ion-row>
          <ion-row class="rating_list_second_row">
            <ion-col class="ion-align-self-center">
              <div class="rating_list_average_rating">
                Average rating:
              </div>
              <div  class="rating_list_float_left">
                <div *ngIf="item.avg_rating>=0 && item.avg_rating<=1">
                  <img class="rating_list_star_size" src="assets/img/rapid-tour/selected_star.svg"/>
                  <img class="rating_list_star_size" src="assets/img/rapid-tour/unselected_star.svg"/>
                  <img class="rating_list_star_size" src="assets/img/rapid-tour/unselected_star.svg"/>
                  <img class="rating_list_star_size" src="assets/img/rapid-tour/unselected_star.svg"/>
                  <img class="rating_list_star_size" src="assets/img/rapid-tour/unselected_star.svg"/>
                </div>
                <div *ngIf="item.avg_rating>1 && item.avg_rating<=2">
                  <img class="rating_list_star_size" src="assets/img/rapid-tour/selected_star.svg"/>
                  <img class="rating_list_star_size" src="assets/img/rapid-tour/selected_star.svg"/>
                  <img class="rating_list_star_size" src="assets/img/rapid-tour/unselected_star.svg"/>
                  <img class="rating_list_star_size" src="assets/img/rapid-tour/unselected_star.svg"/>
                  <img class="rating_list_star_size" src="assets/img/rapid-tour/unselected_star.svg"/>
                </div>
                <div *ngIf="item.avg_rating>2 && item.avg_rating<=3">
                  <img class="rating_list_star_size" src="assets/img/rapid-tour/selected_star.svg"/>
                  <img class="rating_list_star_size" src="assets/img/rapid-tour/selected_star.svg"/>
                  <img class="rating_list_star_size" src="assets/img/rapid-tour/selected_star.svg"/>
                  <img class="rating_list_star_size" src="assets/img/rapid-tour/unselected_star.svg"/>
                  <img class="rating_list_star_size" src="assets/img/rapid-tour/unselected_star.svg"/>
                </div>
                <div *ngIf="item.avg_rating>3 && item.avg_rating<=4">
                  <img class="rating_list_star_size" src="assets/img/rapid-tour/selected_star.svg"/>
                  <img class="rating_list_star_size" src="assets/img/rapid-tour/selected_star.svg"/>
                  <img class="rating_list_star_size" src="assets/img/rapid-tour/selected_star.svg"/>
                  <img class="rating_list_star_size" src="assets/img/rapid-tour/selected_star.svg"/>
                  <img class="rating_list_star_size" src="assets/img/rapid-tour/unselected_star.svg"/>
                </div>
                <div *ngIf="item.avg_rating>4 && item.avg_rating<=5">
                  <img class="rating_list_star_size" src="assets/img/rapid-tour/selected_star.svg"/>
                  <img class="rating_list_star_size" src="assets/img/rapid-tour/selected_star.svg"/>
                  <img class="rating_list_star_size" src="assets/img/rapid-tour/selected_star.svg"/>
                  <img class="rating_list_star_size" src="assets/img/rapid-tour/selected_star.svg"/>
                  <img class="rating_list_star_size" src="assets/img/rapid-tour/selected_star.svg"/>
                </div>
              </div>
              <div class="rating_list_float_right">
                <ion-icon *ngIf="item.check" class="rating_list_right_arrow" name="chevron-down-outline"></ion-icon>
                <ion-icon *ngIf="!item.check" class="rating_list_right_arrow" name="chevron-up-outline"></ion-icon>
              </div>
            </ion-col>
          </ion-row>
          <ion-ripple-effect></ion-ripple-effect>
        </div>
        <ion-grid *ngIf="item.check" class="inner-grid">
          <div *ngFor="let data of (item.zone_list), let j=index">
            <!-- <div *ngFor="let record of (data.all_zone_ratings), let k=index" style="border-bottom:0.01em solid #00738233;" class="ion-activatable ripple-parent" (click)="openDetails(record,k)"> -->
              <ion-row class="rating_list_first_row">
                <ion-col class="ion-align-self-center">
                  <div class="rating_list_id">
                    {{item.area_name}}
                  </div>
                  <div class="rating_list_id">
                    <ion-label class="rating_list_id_alias">{{data.zone_name}}</ion-label>
                  </div>
                  <div class="rating_list_date">
                    {{item.submitted_date | date:'MMMM/yyyy'}}
                  </div>
                </ion-col>
              </ion-row>
              <ion-row class="rating_list_second_row">
                <ion-col class="ion-align-self-center">
                  <div class="rating_list_average_rating">
                    Average rating:
                  </div>
                  <div  class="rating_list_float_left">
                    <div *ngIf="data.zone_details_ratings>=0 && data.zone_details_ratings<=1">
                      <img class="rating_list_star_size" src="assets/img/rapid-tour/selected_star.svg"/>
                      <img class="rating_list_star_size" src="assets/img/rapid-tour/unselected_star.svg"/>
                      <img class="rating_list_star_size" src="assets/img/rapid-tour/unselected_star.svg"/>
                      <img class="rating_list_star_size" src="assets/img/rapid-tour/unselected_star.svg"/>
                      <img class="rating_list_star_size" src="assets/img/rapid-tour/unselected_star.svg"/>
                    </div>
                    <div *ngIf="data.zone_details_ratings>1 && data.zone_details_ratings<=2">
                      <img class="rating_list_star_size" src="assets/img/rapid-tour/selected_star.svg"/>
                      <img class="rating_list_star_size" src="assets/img/rapid-tour/selected_star.svg"/>
                      <img class="rating_list_star_size" src="assets/img/rapid-tour/unselected_star.svg"/>
                      <img class="rating_list_star_size" src="assets/img/rapid-tour/unselected_star.svg"/>
                      <img class="rating_list_star_size" src="assets/img/rapid-tour/unselected_star.svg"/>
                    </div>
                    <div *ngIf="data.zone_details_ratings>2 && data.zone_details_ratings<=3">
                      <img class="rating_list_star_size" src="assets/img/rapid-tour/selected_star.svg"/>
                      <img class="rating_list_star_size" src="assets/img/rapid-tour/selected_star.svg"/>
                      <img class="rating_list_star_size" src="assets/img/rapid-tour/selected_star.svg"/>
                      <img class="rating_list_star_size" src="assets/img/rapid-tour/unselected_star.svg"/>
                      <img class="rating_list_star_size" src="assets/img/rapid-tour/unselected_star.svg"/>
                    </div>
                    <div *ngIf="data.zone_details_ratings>3 && data.zone_details_ratings<=4">
                      <img class="rating_list_star_size" src="assets/img/rapid-tour/selected_star.svg"/>
                      <img class="rating_list_star_size" src="assets/img/rapid-tour/selected_star.svg"/>
                      <img class="rating_list_star_size" src="assets/img/rapid-tour/selected_star.svg"/>
                      <img class="rating_list_star_size" src="assets/img/rapid-tour/selected_star.svg"/>
                      <img class="rating_list_star_size" src="assets/img/rapid-tour/unselected_star.svg"/>
                    </div>
                    <div *ngIf="data.zone_details_ratings>4 && data.zone_details_ratings<=5">
                      <img class="rating_list_star_size" src="assets/img/rapid-tour/selected_star.svg"/>
                      <img class="rating_list_star_size" src="assets/img/rapid-tour/selected_star.svg"/>
                      <img class="rating_list_star_size" src="assets/img/rapid-tour/selected_star.svg"/>
                      <img class="rating_list_star_size" src="assets/img/rapid-tour/selected_star.svg"/>
                      <img class="rating_list_star_size" src="assets/img/rapid-tour/selected_star.svg"/>
                    </div>
                  </div>
                  <div class="rating_list_float_right">
                    <ion-icon  class="rating_list_right_arrow" name="chevron-forward-outline"></ion-icon>
                  </div>
                </ion-col>
              </ion-row>
              <ion-ripple-effect></ion-ripple-effect>
            <!-- </div> -->
          </div>
        </ion-grid>
      </div>

      <ion-infinite-scroll (ionInfinite)="loadMoreSiteData($event)">
        <ion-infinite-scroll-content loadingText="Please wait..." loadingSpinner="bubbles"></ion-infinite-scroll-content>
      </ion-infinite-scroll>
    </ion-list>
  </ion-grid>
</ion-content>
